<div class="main-card"><slot></slot></div>